import { render } from "./ArtificialInsemination.vue?vue&type=template&id=1fd5e068"
import script from "./ArtificialInsemination.vue?vue&type=script&lang=js"
export * from "./ArtificialInsemination.vue?vue&type=script&lang=js"

import exportComponent from "/home/benjamin/projects/web-case/maxstock-firebase/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__